import { createContext } from "react";
import type { AssistenteIAContextoTela, AssistenteIAMensagem } from "../types";

export type AppAssistenteIAContextType = {
	readonly contexto: AssistenteIAContextoTela | null;
	readonly mensagens: AssistenteIAMensagem[];
	readonly aberto: boolean;
	readonly expandido: boolean;
	readonly enviando: boolean;
	readonly limpando: boolean;
	readonly erro: string | null;
	readonly manterContexto: boolean;
	readonly registrarContexto: (contexto: AssistenteIAContextoTela) => void;
	readonly limparContexto: (id: string) => void;
	readonly abrir: () => void;
	readonly fechar: () => void;
	readonly alternarExpandido: () => void;
	readonly definirManterContexto: (valor: boolean) => void;
	readonly enviarMensagem: (conteudo: string) => void;
	readonly limparConversa: () => void;
};

export const AppAssistenteIAContext = createContext<AppAssistenteIAContextType | undefined>(undefined);
